import {
  Box,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Tooltip,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { LuMapPin } from 'react-icons/lu';
import { IJob } from 'wisestep-api';
import { WsColors, WsLocationSearch, WsTypoColors, WsTypography } from 'wisestep-base';

import WsAccordion from './WsAccordion';
interface AiLocationsProps {
  name: string;
  job: IJob;
}

const AiLocationFilter = ({ name, job }: AiLocationsProps) => {
  const { control, getValues, setValue, watch } = useFormContext();
  const [open, setOpen] = useState<boolean>(false);

  const [value, setValues] = useState<string[]>([]);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    location[(event.target as HTMLInputElement).value]();

  const location = useMemo(() => {
    const formatLocation = (fields: string[]) => {
      setValue('customLocations', []);
      if (!job.locations || job.locations.length === 0) return;
      const text = Array.from(
        new Set(job.locations.map((job) => fields.map((field) => job?.[field] || 'N/A').join(',')))
      );
      setValues(text);
    };

    return {
      'Same City as Job': () => formatLocation(['city', 'state', 'country']),
      'Same State as Job': () => formatLocation(['state', 'country']),
      'Same Country as Job': () => formatLocation(['country']),
      custom: () => setValues(['custom']),
    };
  }, [job.locations, setValue]);

  const nameVale = watch(name);
  useEffect(() => {
    if (nameVale) location[getValues(name)]();
  }, [nameVale, location, name, getValues]);

  return (
    <WsAccordion title="Locations" defaultExpanded={true} startIcon={<LuMapPin />}>
      <Box>
        {value && value[0] !== 'custom' && (
          <Grid container alignItems="center" columnGap={1}>
            <Chip
              label={<WsTypography>{value[0]}</WsTypography>}
              sx={{ bgcolor: WsColors.TheBlues500 }}
            />
            {value.length > 1 && (
              <Tooltip title={value.slice(1).join('\n')} open={open} onClose={() => setOpen(false)}>
                <Box>
                  <WsTypography
                    onClick={() => setOpen(true)}
                    cursor="pointer"
                    color={WsTypoColors.PRIMARY}
                  >{`+${value.length - 1} more`}</WsTypography>
                </Box>
              </Tooltip>
            )}
          </Grid>
        )}
        <FormControl fullWidth size="small">
          <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <RadioGroup value={value} onChange={onChange} row={false}>
                <FormControlLabel
                  value="Same City as Job"
                  label="Same City as Job"
                  control={<Radio onChange={handleChange} size="small" />}
                />
                <FormControlLabel
                  value="Same State as Job"
                  label="Same State as Job"
                  control={<Radio onChange={handleChange} size="small" />}
                />
                <FormControlLabel
                  value="Same Country as Job"
                  label="Same Country as Job"
                  control={<Radio onChange={handleChange} size="small" />}
                />
                <FormControlLabel
                  value="custom"
                  label={
                    <Box minWidth={250}>
                      <WsLocationSearch
                        disabled={value === 'custom' ? false : true}
                        hideLabel={true}
                        size="small"
                        placeHolder="Custom Location"
                        multiSelect={true}
                        name={'customLocations'}
                      />
                    </Box>
                  }
                  control={<Radio onChange={handleChange} size="small" />}
                />
              </RadioGroup>
            )}
          />
        </FormControl>
      </Box>
    </WsAccordion>
  );
};
export default AiLocationFilter;
